const PropTypes = require('prop-types');
const React = require('react');

const AddToCartButton = require('components/listings/cart/add_to_cart_button.jsx');
const Upsells = require('components/product_show_page/upsells.jsx');
const UpsellPlaceholder = require('components/product_show_page/upsell_placeholder.jsx');

const ModalUpsells = (props) => (
  <Upsells
    listingId={props.listingId}
    className={props.className}
    children={props.children}
    aid={'related_content_upsells_modal'}
    addToCartButton={AddToCartButton}
    placeholder={<UpsellPlaceholder />}
  />
);

ModalUpsells.propTypes = {
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
};

module.exports = ModalUpsells;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/modal_upsells.jsx